import { AsyncPipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'opportunity-type',
  templateUrl: './opportunity-type.component.html',
  styleUrls: ['./opportunity-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class OpportunityTypeComponent implements OnInit {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);
  constructor() {}

  ngOnInit(): void {}
  parseOpportunity(info: any, adata: any) {
    return adata.find((item: any) => {
      if (info == item.id) {
        return item;
      } else {
        null;
      }
    });
  }
}
